const readInviteTokenFromRedirect = (redirect: string | null) => {
    if (!redirect) {
        return '';
    }

    try {
        const redirectUrl = new URL(redirect, 'https://bustly.local');
        return redirectUrl.searchParams.get('invite_token')?.trim() || '';
    } catch {
        return '';
    }
};

export const readOnboardingInviteToken = (search: string = '') => {
    const searchParams = new URLSearchParams(search);
    return searchParams.get('invite_token')?.trim()
        || readInviteTokenFromRedirect(searchParams.get('redirect'));
};

export const buildOnboardingRoutePreservingInvite = (search: string = '') => {
    const inviteToken = readOnboardingInviteToken(search);

    if (!inviteToken) {
        return '/onboarding';
    }

    const nextSearchParams = new URLSearchParams();
    nextSearchParams.set('invite_token', inviteToken);
    return `/onboarding?${nextSearchParams.toString()}`;
};
